import { connect, MapStateToProps } from "react-redux";

import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { areMenuPanelCaptionsVisible } from "../../selectors";
import { MenuPanelComponentProps } from "../MenuPanelComponent";

const mapStateToProps: MapStateToProps<MenuPanelComponentProps, NoneOwnProps, IAppState> = (state) => ({
    wider: areMenuPanelCaptionsVisible(state),
});

/**
 * Napojuje komponentu panelu menu. Pro komponentu získá příznak zda položky menu panelu mají zobrazit popisky.
 * Podle toho se nastaví šířka panelu.
 */
export const MenuPanel = connect(mapStateToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.MenuPanelComponent));
